import { useRef, useCallback } from 'react';

// Returns a debounced version of callback that ignores calls within `delay`ms
export const useDebounceClick = (callback, delay = 300) => {
  const lastClick = useRef(0);
  return useCallback((...args) => {
    const now = Date.now();
    if (now - lastClick.current < delay) return;
    lastClick.current = now;
    callback(...args);
  }, [callback, delay]);
};
